import { ReactNode } from 'react'
import { StoryblokImage } from '@cinch-nx/data-storyblok'

import { StarRating } from '../star-rating'
import { Author } from '../author'
import { Media } from '../media'

import styles from './intro.module.css'
import sharedStyles from '../../car-reviews-v2.module.css'
import { CarReviewV2Video } from '../../types/car-review-page'

export interface IntroProps {
  contentTitle: string
  contentStarRating: number
  contentIntroText: ReactNode
  authorImage: StoryblokImage
  authorName: string
  imageCount: number
  introImage: StoryblokImage
  latestPublishDate: string
  video: CarReviewV2Video[] | undefined
}

export const Intro = ({
  contentTitle,
  contentStarRating,
  contentIntroText,
  authorImage,
  authorName,
  imageCount,
  introImage,
  latestPublishDate,
  video,
}: IntroProps) => (
  <div className={sharedStyles.inner}>
    <h1 className={styles.heading}>{contentTitle}</h1>

    <StarRating starRating={Number(contentStarRating)} />

    <div className={sharedStyles.reviewCopy}>{contentIntroText}</div>

    <Author
      name={authorName}
      image={authorImage}
      latestPublishDate={latestPublishDate}
    />

    <Media
      imageCount={imageCount}
      imageSrc={introImage.filename}
      alt={introImage.alt ?? ''}
      video={video}
    />
  </div>
)
